import React from "react";

const styles = {
  container: {
    maxWidth: 720,
    margin: "0 auto",
    padding: 24,
    color: "#111827",
    lineHeight: 1.6,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  h1: { fontSize: 26, fontWeight: "700", marginBottom: 8 },
  h2: { fontSize: 18, fontWeight: "600", marginTop: 24, marginBottom: 8 },
  p: { marginBottom: 12 },
  ul: { paddingLeft: 20, marginBottom: 12 },
  li: { marginBottom: 6 },
  link: { color: "#2563EB", textDecoration: "none" },
  hr: { border: 0, borderTop: "1px solid #E5E7EB", margin: "24px 0" },
};

const DeletePrivacyPolicy=()=> {
  return (
    <div style={styles.container}>
      <h1 style={styles.h1}>Delete Account & Data Policy</h1>
      <p>
        At <b>TeamTrack</b>, we value your privacy and give you full control
        over your account and data. This page explains what happens when you
        delete your account.
      </p>

      <h2 style={styles.h2}>1. How to Delete Your Account</h2>
      <p>
        You can delete your account anytime by going to{" "}
        <b>Settings → Delete Account</b> in the TeamTrack app.
      </p>
      <p>
        After confirming deletion, your account will be marked for removal and
        all related data will be permanently deleted from our system.
      </p>

      <h2 style={styles.h2}>2. What Data Gets Deleted</h2>
      <ul style={styles.ul}>
        <li>Username and email address</li>
        <li>Hashed password credentials</li>
        <li>Check-in and check-out logs</li>
        <li>IP and location history</li>
        <li>Any stored analytics or activity records</li>
      </ul>
      <p>
        All associated records are <b>permanently deleted</b> from our
        PostgreSQL (pgAdmin) database within <b>30 days</b> of deletion. Once
        removed, this data cannot be recovered.
      </p>

      <h2 style={styles.h2}>3. Backup and Logs</h2>
      <p>
        Backups (if any) that may contain fragments of your data are
        automatically overwritten or purged within 30 days of deletion.
      </p>

      <h2 style={styles.h2}>4. Effects of Deletion</h2>
      <ul style={styles.ul}>
        <li>You’ll lose access to your TeamTrack account permanently.</li>
        <li>Your logs and check-in history will no longer be visible.</li>
        <li>No notifications or emails will be sent after deletion.</li>
      </ul>

      <h2 style={styles.h2}>5. Need Help?</h2>
      <p>
        If you experience any issues or wish to confirm your data deletion,
        please email us at{" "}
        <a href="mailto:support@teamtrack.sticompanysrl.app" style={styles.link}>
          support@teamtrack.sticompanysrl.app
        </a>
        .
      </p>

      <hr style={styles.hr} />
      <p>
        <small>© 2025 TeamTrack. All rights reserved.</small>
      </p>
    </div>
  );
}

export default DeletePrivacyPolicy